export default __webpack_public_path__ + "static/media/menu_middle.1f6bc2c5.svg";